import { render } from "./Slider.vue?vue&type=template&id=9c702e18"
import script from "./Slider.vue?vue&type=script&lang=js"
export * from "./Slider.vue?vue&type=script&lang=js"

import "./Slider.vue?vue&type=style&index=0&id=9c702e18&lang=css"
script.render = render

export default script